import cx from 'classnames';
import styles from './Checkbox.module.scss';

import { Typography } from '../Typography';

interface CheckboxProps {
  error?: boolean;
  checked: boolean;
  className?: string;
  checkboxText?: string;
  setError?: (error: boolean) => void;
  setChecked: (checked: boolean) => void;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  setError,
  className,
  setChecked,
  checkboxText,
  error = false,
}) => {
  return (
    <label className={cx(styles.label, className)}>
      <input
        type="checkbox"
        checked={checked}
        className={styles.input}
        onChange={() => {
          setChecked(!checked);
          if (setError) setError(false);
        }}
      />
      <div
        className={cx(
          styles.checkbox,
          { [styles.error]: error },
          { [styles.checked]: checked },
        )}
      />
      {checkboxText && (
        <Typography
          component="description"
          className={styles.checkboxText}
          onChange={() => setChecked(!checked)}
        >
          {checkboxText}
        </Typography>
      )}
    </label>
  );
};
